import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import CommentsOnly from "./components/Comments/CommentsOnly";
import registerServiceWorker from './registerServiceWorker';
import LastCommentsOnly from "./components/Comments/LastCommentsOnly";
import LastComboCommentsOnly from "./components/Comments/LastCombo/LastComboCommentsOnly";
import SpyingOnly from "./components/Spying/SpyingOnly";

window.initNewSiteParts=function() {
  const commentsRootList=document.querySelectorAll('.commentsV2');
  const lastCommentsRoot=document.getElementById('lastComments');
  const lastComboCommentsRoot=document.getElementById('lastComboComments');
  const spyingRoot=document.getElementById('spyingRoot');
  const mainRoot=document.getElementById('root');

  if (mainRoot) {
    ReactDOM.render(<App/>, mainRoot);
    registerServiceWorker();
  }
  if (commentsRootList && commentsRootList.length>0) {
    for(let i in commentsRootList) {
      const commentsRoot=commentsRootList[i];
      if (commentsRoot && commentsRoot.dataset && !commentsRoot.dataset.loaded) {
        const props = commentsRoot.dataset;
        console.log('CommentsOnly',props);
        commentsRoot.dataset.loaded = 1;
        ReactDOM.render(<CommentsOnly {...props}/>, commentsRoot);
      }
    }
  }
  if (lastCommentsRoot) {
    if (!lastCommentsRoot.dataset.loaded) {
      const props = lastCommentsRoot.dataset;
      lastCommentsRoot.dataset.loaded = 1;
      ReactDOM.render(<LastCommentsOnly {...props}/>, lastCommentsRoot);
    }
  }
  if(lastComboCommentsRoot) {
    if (!lastComboCommentsRoot.dataset.loaded) {
      const props = lastComboCommentsRoot.dataset;
      lastComboCommentsRoot.dataset.loaded = 1;
      ReactDOM.render(<LastComboCommentsOnly {...props}/>, lastComboCommentsRoot);
    }
  }
  if(spyingRoot) {
    if (!spyingRoot.dataset.loaded) {
      const props = spyingRoot.dataset;
      spyingRoot.dataset.loaded = 1;
      ReactDOM.render(<SpyingOnly {...props}/>, spyingRoot);
    }
  }
}

window.initNewSiteParts();


